import {
  AttributeAssessmentId,
  AttributeCitation,
  ComplexityAssessmentId,
  RecordAttributeCitation,
  SourceExtractId,
} from "platformed-client/types";

import {platformedClient} from "../..";
import {invalidateQueries, q} from "../../../state";

// A citation change can reflow the attribute's value, which feeds the tier, so
// the list mins and the rollup widget refresh with the attribute.
async function invalidate(
  complexityAssessmentId: ComplexityAssessmentId,
  attributeAssessmentId: AttributeAssessmentId,
) {
  await invalidateQueries([
    q.tprm.complexityAssessment.filter(complexityAssessmentId),
    q.tprm.complexityAssessmentMember.filter(complexityAssessmentId),
    q.tprm.complexityAssessmentScopes.filter(complexityAssessmentId),
    q.tprm.attributeCitations.filter(complexityAssessmentId, attributeAssessmentId),
    q.tprm.engagementComplexityAssessmentBatches.filter(),
    q.tprm.engagementComplexityAssessments.filter(),
    q.tprm.thirdPartyComplexityAssessments.filter(),
    q.tprm.usedComplexityTiersOnAccount.filter(),
  ]);
}

export async function add(
  complexityAssessmentId: ComplexityAssessmentId,
  attributeAssessmentId: AttributeAssessmentId,
  records: RecordAttributeCitation[],
): Promise<AttributeCitation[]> {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/attribute_assessment/{attribute_assessment_id}/citations",
    {
      path: {complexity_assessment_id: complexityAssessmentId, attribute_assessment_id: attributeAssessmentId},
      body: records,
    },
  );
  await invalidate(complexityAssessmentId, attributeAssessmentId);
  return res;
}

export async function list(
  complexityAssessmentId: ComplexityAssessmentId,
  attributeAssessmentId: AttributeAssessmentId,
): Promise<AttributeCitation[]> {
  return await platformedClient.internalRequest(
    "get",
    "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/attribute_assessment/{attribute_assessment_id}/citations",
    {path: {complexity_assessment_id: complexityAssessmentId, attribute_assessment_id: attributeAssessmentId}},
  );
}

export async function updateContext(
  complexityAssessmentId: ComplexityAssessmentId,
  attributeAssessmentId: AttributeAssessmentId,
  sourceExtractId: SourceExtractId,
  context: string | null,
): Promise<void> {
  await platformedClient.internalRequest(
    "put",
    "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/attribute_assessment/{attribute_assessment_id}/citations/{source_extract_id}",
    {
      path: {
        complexity_assessment_id: complexityAssessmentId,
        attribute_assessment_id: attributeAssessmentId,
        source_extract_id: sourceExtractId,
      },
      body: {context},
    },
  );
  await invalidate(complexityAssessmentId, attributeAssessmentId);
}

export async function remove(
  complexityAssessmentId: ComplexityAssessmentId,
  attributeAssessmentId: AttributeAssessmentId,
  sourceExtractId: SourceExtractId,
): Promise<void> {
  await platformedClient.internalRequest(
    "delete",
    "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/attribute_assessment/{attribute_assessment_id}/citations/{source_extract_id}",
    {
      path: {
        complexity_assessment_id: complexityAssessmentId,
        attribute_assessment_id: attributeAssessmentId,
        source_extract_id: sourceExtractId,
      },
    },
  );
  await invalidate(complexityAssessmentId, attributeAssessmentId);
}
